import { useState, useRef } from "react";

const useSearch = (type?: string) => {
  const [searchType, setSearchType] = useState<string | null>(type || "mac");
  const [searchWord, setSearchWord] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSearch = async (
    e:
      | React.MouseEvent<HTMLButtonElement>
      | React.KeyboardEvent<HTMLInputElement>
  ) => {
    e.preventDefault();

    if (e.type === "keyup" && (e as React.KeyboardEvent).key !== "Enter") {
      return;
    }

    if (inputRef.current) {
      setSearchWord(inputRef.current.value);
      setPage(1);
    }
  };

  return {
    searchType,
    setSearchType,
    setSearchWord,
    page,
    setPage,
    searchWord,
    inputRef,
    handleSearch,
  };
};

export default useSearch;
